import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  circularProgress: {
    height: '100%',
    width: '100%',
  },
}))
export { useStyles }
